import React, { PureComponent } from 'react';
import { isMobile } from 'react-device-detect';

class HomeInternal extends PureComponent {
  constructor(props) {
    super(props);
    
    this.state = {
      logo: this.props.logo,
    };
  }
  render() {
    return (
      <section className="home-slider internal">    
      <div className="container">
        {this.state.logo &&
          <center>
            <img src={process.env.PUBLIC_URL + `/assets/images/logo-${this.state.logo}.png`} alt={this.state.logo} className={ isMobile ? 'logo-internal-mobile' : 'logo-internal'} /> 
          </center>
        }
        {this.state.logo != true &&
          <div className="internal-no-logo">
            &nbsp;
          </div>        
        }
      </div>      
      </section>
    )
  }
}

export default HomeInternal;